import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/utils/AuthContext';
import { METRIKA_ID, setVisitorParams } from '@/utils/analytics';

export { METRIKA_ID, reachGoal } from '@/utils/analytics';

export function YandexMetrika() {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    if (typeof window.ym === 'function') {
      window.ym(METRIKA_ID, 'hit', window.location.href);
    }
  }, [location.pathname]);

  // Tariff as a visitor param, so every report can be split into free vs paid.
  useEffect(() => {
    if (!user?.id) return;
    setVisitorParams(user.id, {
      tier: user.unlimited ? 'unlimited' : user.subscription_tier,
      ...(user.subscription_billing_period ? { billing_period: user.subscription_billing_period } : {}),
    });
  }, [user?.id, user?.subscription_tier, user?.unlimited, user?.subscription_billing_period]);

  return null;
}
